module.exports = __webpack_public_path__ + "img/material-content-copy.bb219a71.svg";